const mode = process.env.REACT_APP_API_ENV || process.env.REACT_APP_MODE;
export const baseURL = {
    development: 'https://dev-apaas.grtcloud.net/api',
    test: 'https://test-apaas.grtcloud.net/api',
    production: 'https://apaas.grtcloud.net/api',
    local: 'https://test-apaas.grtcloud.net/api'
}[mode];

export const loginURL = {
    development: 'https://dev-passport.grtcloud.net/',
    test: 'https://test-passport.grtcloud.net/',
    production: 'https://passport.grtcloud.net/',
    local: 'https://test-passport.grtcloud.net/'
}[mode];
export const passPortURL = {
    development: 'https://dev-passport.grtcloud.net',
    test: 'https://test-passport.grtcloud.net',
    production: 'https://passport.grtcloud.net',
    local: 'https://test-passport.grtcloud.net'
}[mode];
export const mobileURL = {
    development: 'https://test-client-mobile.grtcloud.net',
    test: 'https://test-client-mobile.grtcloud.net',
    production: 'https://client-mobile.grtcloud.net',
    local: 'https://client-mobile.grtcloud.net'
}[mode];
export const staticUrl = {
    development: 'https://test-lowcode.grtcloud.net/static_main',
    test: 'https://test-lowcode.grtcloud.net/static_main',
    production: 'https://lowcode.grtcloud.net/static_main',
    local: 'https://test-lowcode.grtcloud.net/static_main'
}[mode];
//神策埋点url
export const ShenCeUrl = {
    development: 'https://test-dc-ptc.grtcloud.net/',
    test: 'https://test-dc-ptc.grtcloud.net/',
    production: 'https://dc-ptc.grtcloud.net/',
    local: 'https://test-dc-ptc.grtcloud.net/'
}[mode];
const URL = {
    assetJson: staticUrl + '/assets.json',
    getVersion: baseURL + '/application/webpage/v1/lastest'
};

export default URL;
